import { supabase } from './supabase';
import { miners } from './miners';
import { toast } from 'react-hot-toast';
import { updateMinersCache } from './miners';

export async function setupInitialData() {
  try {
    console.log('Starting initial setup...');
    
    // Check if miners table exists and has data
    const { count, error: countError } = await supabase
      .from('miners')
      .select('*', { count: 'exact', head: true });

    if (countError) throw countError;
    
    // Only populate if table is empty
    if (count === 0) {
      console.log('Initializing miners collection...');
      
      // Format miners data for Supabase
      const minersData = miners.map(miner => ({
        model: miner.model,
        name: miner.name,
        algorithm: miner.algorithm,
        hashrate: miner.hashrate,
        hashrate_unit: miner.hashrateUnit,
        power: miner.power,
        coin: miner.coin,
        manufacturer: miner.manufacturer,
        release_year: miner.releaseYear,
        status: miner.status || 'current',
        specs: {
          efficiency: miner.efficiency,
          noise: miner.noise,
          cooling: miner.cooling,
          interface: miner.interface,
          temperature: miner.temperature,
          humidity: miner.humidity,
          supportedCoins: miner.supportedCoins
        },
        created_at: new Date().toISOString(),
        updated_at: new Date().toISOString()
      }));

      // Insert miners in batches to avoid size limits
      const BATCH_SIZE = 50;
      for (let i = 0; i < minersData.length; i += BATCH_SIZE) {
        const batch = minersData.slice(i, i + BATCH_SIZE);
        const { error: insertError } = await supabase
          .from('miners')
          .insert(batch);

        if (insertError) throw insertError;
      }
      
      // Update local cache
      updateMinersCache(minersData);
      
      console.log('Miners collection initialized');
      toast.success('Database initialized successfully');
    } else {
      // Fetch existing miners to update cache
      const { data: existingMiners, error: fetchError } = await supabase
        .from('miners')
        .select('*')
        .order('release_year', { ascending: false });

      if (fetchError) throw fetchError;
      
      if (existingMiners) {
        // Convert snake_case to camelCase for cache
        const formattedMiners = existingMiners.map(miner => ({
          ...miner,
          hashrateUnit: miner.hashrate_unit,
          releaseYear: miner.release_year
        }));
        updateMinersCache(formattedMiners);
      }
      
      console.log('Miners collection already exists');
    }
  } catch (error: any) {
    console.error('Setup error:', error);
    toast.error('Failed to initialize database');
    throw error;
  }
}